<template>
	<tile-card
		elevation="0"
		aspect-ratio="1.5"
		:disabled="loading"
		@click="navigate"
	>
		<v-list-item class="flex-title" two-line>
			<v-list-item-content>
				<div class="user-type overline">
					{{ title }}
				</div>
				<v-list-item-title class="name headline">
					{{ subtitle }}
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<div class="body">
			<v-icon color="grey lighten-1">fa-door-open</v-icon>
		</div>

		<template #actions>
			<v-spacer />
			<v-btn class="action-btn" :ripple="false" text>
				{{ actionText }}
				<v-icon class="ml-2" x-small>fa fa-arrow-right</v-icon>
			</v-btn>
		</template>
	</tile-card>
</template>

<script>
import _ from "lodash";

import TileCard from "../../shared/TileCard";

export default {
	components: { TileCard },

	props: ["loading", "system"],

	computed: {
		systemId() {
			const propSysId = _.get(this.system, "identifier");
			const paramSysId = _.get(this.$route, "params.systemId");
			return propSysId || paramSysId || null;
		},

		title() {
			return "System";
		},

		subtitle() {
			return (
				_.get(this.system, "name") || _.get(this.$route, "params.systemId")
			) || "Select System";
		},

		actionText() {
			return this.systemId ? "View System" : "Select System";
		}
	},

	methods: {
		navigate() {
			if (this.systemId) {
				return this.$router.push({
					name: "Live System",
					params: { systemId: this.systemId },
				});
			}

			return this.$router.push({ name: "Live System Select" });
		},
	},
};
</script>
